import type { CustodianActivityMetricsCounts } from './activities.queries';

export type CustodianActivityMetricsFields =
  Partial<CustodianActivityMetricsCounts> | null;

export type ActivitiesMetricsTiles = {
  occurringToday: number;
  created: number;
  reconciledToday: number;
  agingPending: number;
};

const toCount = (value: number | null | undefined): number => value ?? 0;

/** Maps org-scoped metrics to display-only tile counts (UTC windows from BE). */
export const mapActivitiesMetrics = (
  metrics: CustodianActivityMetricsFields | undefined,
): ActivitiesMetricsTiles => ({
  occurringToday: toCount(metrics?.occurringTodayCount),
  created: toCount(metrics?.createdCount),
  reconciledToday: toCount(metrics?.reconciledTodayCount),
  agingPending: toCount(metrics?.agingPendingCount),
});
